module.exports = "/_next/static/files/e81e534493b654a05e112259829f565c.png";